<app-modal-window title="Валютный отыгрыш"
                  [actions]="true"
                  (close)="close()"
                  [disabledConfirm]="paybackWalletForm.invalid"
                  (confirm)="onSubmit()">
  <div class='payback-content'>

    <div *ngIf="data?.paybackWallet as pw" class="current-payback">
      Текущий отыгрыш: <b>{{ (pw.payback / 100) | number : '1.3-3' }}</b>
    </div>

    <form [formGroup]="paybackWalletForm" class="payback-form">

      <mat-form-field class="form-field" appearance="outline">
        <mat-label>Wallet type</mat-label>
        <mat-select formControlName="walletType">
          <mat-option *ngFor="let item of Object.values(WalletTypeEnum)" [value]="item">
            {{ item }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="form-field" appearance="outline">
        <mat-label>Payback (delta, &lt; 0 — списать)</mat-label>
        <input matInput type="number" formControlName="payback" placeholder="number">
      </mat-form-field>
    </form>

  </div>
</app-modal-window>
